module.exports = __webpack_public_path__ + "static/logo-7143fed90277460a74d1e30fce8a3143.png";